import React from "react";
import { decodeHtmlElements } from './common/helpers.js'
import { Policies } from "../components/cancellation-policy/CancellationPolicy"

const Policy = ({ allowCancel, allowUpdate, producerName }) => (
  <div className="">
    <div className="r_policyContainer">
      <Policies allowCancel={allowCancel} allowUpdate={allowUpdate } />
    </div>
    <div>
      {producerName && (
        <span style={{fontSize: 12}}>
          {cancellationpolicy_resources.ContactOrganizerInfo}
                    {' '}<strong>{decodeHtmlElements(producerName)}</strong>.
        </span>
      )}{" "}
      <span style={{fontSize: 12}}>{cancellationpolicy_resources.LinkProducerForPolicyBody}</span>
    </div>
  </div>
);

export default Policy;
